howspace.blueprints ??= {};

howspace.blueprints.initConfirmDeleteModal = (modal) => {
    modal = $(modal);

    const workspaceBlueprintId = modal.data('workspace-blueprint-id');
    const row = $('.howspace-lister-table tr.workspace-blueprint-row[data-workspace-blueprint-id="' + workspaceBlueprintId + '"]');
    const lister = $('#workspace-blueprints-lister');

    modal.on('click', '.confirm-delete-workspace-blueprint-btn', function () {
        const confirmBtn = $(this);

        real.button.loading(confirmBtn, modal);

        real.ajax.json(real.baseUri + '/api/blueprints/' + workspaceBlueprintId + '/delete', {
            type: 'POST',
            success: function () {
                real.button.reset(confirmBtn);
                row.remove();
                howspace.components.modal.close(modal[0]);

                if (lister.find('tr.workspace-blueprint-row').length === 0) {
                    howspace.components.lister.reload(lister);
                }
            },
            error: function () {
                real.button.reset(confirmBtn);
            }
        });
    });
};

howspace.blueprints.initCreateModal = (modal) => {
    modal = $(modal);

    const content = modal.find('.workspace-blueprint-create-content');
    const blueprintId = content.data('workspace-blueprint-id');
    const blueprintName = $.trim(String(content.data('workspace-blueprint-name') || ''));
    const formSection = content.find('.workspace-blueprint-create-form');
    const actionsSection = content.find('.workspace-blueprint-create-actions');
    const progressSection = content.find('.workspace-blueprint-create-progress');
    const progressBar = progressSection.find('.howspace-progress');
    const statusElem = content.find('.workspace-blueprint-create-status');
    const resultSection = content.find('.workspace-blueprint-create-result');
    const resultMessage = content.find('.workspace-blueprint-create-result-message');
    const createBtn = content.find('.workspace-blueprint-create-btn');
    const deploymentTarget = content.find('.workspace-blueprint-deployment-target');
    const workspaceNameInput = content.find('input.workspace-name');
    const workspaceDomainInput = content.find('input.workspace-domain');
    const paidOnlyFields = content.find('.workspace-blueprint-paid-only');
    let activeRequestId = null;
    let isCreating = false;

    const hasDomainError = (response) => {
        let domainError = false;
        real.ajax.loopErrors(response, (error) => {
            if (error.property === 'workspace_domain') {
                domainError = true;
            }
        });
        return domainError;
    };

    const isDraftTarget = () => deploymentTarget.val() === 'draft';

    const setStatus = (text) => {
        statusElem.text(text);
    };

    const hideProgressBarText = () => {
        progressBar.find('.howspace-progress-text').text('').addClass('d-none');
    };

    const setProgressStable = () => {
        progressBar.find('.howspace-progress-bar')
            .removeClass('howspace-progress-bar-striped-animated')
            .removeClass('howspace-progress-bar-striped');
    };

    const togglePaidFields = () => {
        if (isCreating) {
            return;
        }

        if (isDraftTarget()) {
            paidOnlyFields.addClass('d-none');
            workspaceDomainInput.removeClass('is-invalid');
        } else {
            paidOnlyFields.removeClass('d-none');
        }
    };

    const checkCreateEnabled = () => {
        if (isCreating) {
            createBtn.prop('disabled', true);
            return;
        }

        const hasTarget = $.trim(String(deploymentTarget.val() || '')) !== '';
        const hasName = $.trim(workspaceNameInput.val()) !== '';
        const hasDomain = isDraftTarget() || $.trim(workspaceDomainInput.val()) !== '';
        const hasValidDomain = isDraftTarget() || !workspaceDomainInput.hasClass('is-invalid');

        createBtn.prop('disabled', !(hasTarget && hasName && hasDomain && hasValidDomain));
    };

    const syncDomainFromWorkspaceName = () => {
        if (isCreating) {
            return;
        }

        if (workspaceDomainInput.length === 0 || workspaceDomainInput.data('manually-edited') || isDraftTarget()) {
            return;
        }

        workspaceDomainInput.val(workspaceNameInput.val());
        workspaceDomainInput.removeClass('is-invalid');
        real.input.validateWorkspaceDomainLocal.call(workspaceDomainInput[0]);
        workspaceDomainInput.val(workspaceDomainInput.val().substring(0, 56));
        real.input.validateWorkspaceDomainLocalBlur.call(workspaceDomainInput[0]);
    };

    const validateWorkspaceDomain = () => {
        if (isCreating) {
            return;
        }

        if (isDraftTarget()) {
            workspaceDomainInput.removeClass('is-invalid');
            checkCreateEnabled();
            return;
        }

        real.input.validateWorkspaceDomain(
            modal,
            () => {
                if (isCreating) {
                    return;
                }

                workspaceDomainInput.removeClass('is-invalid');
                checkCreateEnabled();
            },
            () => {
                if (isCreating) {
                    return;
                }

                howspace.form.markInvalidField(workspaceDomainInput);
                checkCreateEnabled();
            }
        );
    };

    const showForm = () => {
        isCreating = false;
        formSection.removeClass('d-none');
        actionsSection.removeClass('d-none');
        checkCreateEnabled();
    };

    const showProgressOnly = () => {
        isCreating = true;
        formSection.addClass('d-none');
        actionsSection.addClass('d-none');
        progressSection.removeClass('d-none');
        resultSection.addClass('d-none');
        workspaceDomainInput.removeClass('is-invalid');
        createBtn.prop('disabled', true);
    };

    const redirectToWorkspace = (url) => {
        if (typeof url !== 'string' || url.trim() === '') {
            resultSection.removeClass('d-none');
            resultMessage.text(howspace.translate('my_workspace_blueprint_creation_done'));
            return;
        }

        window.setTimeout(() => {
            window.location.href = url.trim();
        }, 0);
    };

    const getCompletedWorkspaceUrl = notification => {
        const candidates = [
            notification.object?.link?.url,
            notification.object?.link_url,
            notification.object?.workspace?.login_link_url,
            notification.object?.workspace?.url,
        ];

        return candidates.find(candidate => typeof candidate === 'string' && candidate.trim() !== '') || '';
    };

    deploymentTarget.on('change', () => {
        togglePaidFields();
        syncDomainFromWorkspaceName();
        validateWorkspaceDomain();
        checkCreateEnabled();
    });

    workspaceNameInput.on('input', () => {
        syncDomainFromWorkspaceName();
        validateWorkspaceDomain();
        checkCreateEnabled();
    });

    workspaceDomainInput.on('input', () => {
        workspaceDomainInput.data('manually-edited', true);
        workspaceDomainInput.removeClass('is-invalid');
        real.input.validateWorkspaceDomainLocal.call(workspaceDomainInput[0]);
        checkCreateEnabled();
    });

    workspaceDomainInput.on('blur', () => {
        real.input.validateWorkspaceDomainLocalBlur.call(workspaceDomainInput[0]);
        validateWorkspaceDomain();
    });

    content.on('click', '.randomize-workspace-name-btn', () => {
        if (isCreating) {
            return;
        }

        workspaceNameInput.val(howspace.generateRandomWorkspaceName()).trigger('input');
    });

    real.events.on('workspace:generation:progress', (notification) => {
        if (
            notification.object?.request_id !== activeRequestId ||
            !document.body.contains(modal[0])
        ) {
            return;
        }

        progressSection.removeClass('d-none');
        const statusText = notification.object.progress?.status_text || howspace.translate('my_workspace_blueprint_creation_waiting');
        setStatus(statusText);
        howspace.components.progress.update(progressBar, notification.object.progress?.percentage || 0);
        hideProgressBarText();
    });

    real.events.on('workspace:generation:completed', (notification) => {
        if (
            notification.object?.request_id !== activeRequestId ||
            !document.body.contains(modal[0])
        ) {
            return;
        }

        const url = getCompletedWorkspaceUrl(notification);

        progressSection.removeClass('d-none');
        setProgressStable();
        setStatus(howspace.translate('my_workspace_blueprint_creation_done'));
        howspace.components.progress.update(progressBar, 100);
        hideProgressBarText();

        redirectToWorkspace(url);
    });

    real.events.on('workspace:generation:failed', (notification) => {
        if (
            notification.object?.request_id !== activeRequestId ||
            !document.body.contains(modal[0])
        ) {
            return;
        }

        real.button.reset(createBtn, modal.find('.modal-body'));
        showForm();

        progressSection.removeClass('d-none');
        setProgressStable();
        setStatus(howspace.translate('my_workspace_blueprint_creation_failed'));
        hideProgressBarText();
        resultSection.removeClass('d-none');
        resultMessage.text(notification.object.error || howspace.translate('my_workspace_blueprint_creation_failed'));
    });

    createBtn.on('click', () => {
        if (createBtn.prop('disabled')) {
            return;
        }

        real.button.loading(createBtn, modal.find('.modal-body'));
        showProgressOnly();

        const dataPayload = {
            deployment_target: $.trim(String(deploymentTarget.val() || '')),
            workspace_name: $.trim(workspaceNameInput.val()),
        };

        if (!isDraftTarget()) {
            dataPayload.workspace_domain = $.trim(workspaceDomainInput.val()) + content.find('.workspace-root-domain').text();
        }

        setStatus(howspace.translate('my_workspace_blueprint_creation_waiting'));
        howspace.components.progress.reset(progressBar);

        real.ajax.json(real.baseUri + '/api/blueprints/' + blueprintId + '/create', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            logError: response => {
                return !hasDomainError(response);
            },
            showErrorNotification: response => {
                return !hasDomainError(response);
            },
            success: response => {
                activeRequestId = response.request_id;
                real.button.reset(createBtn, modal.find('.modal-body'));
                createBtn.prop('disabled', true);
            },
            error: response => {
                real.button.reset(createBtn, modal.find('.modal-body'));
                showForm();
                if (hasDomainError(response)) {
                    howspace.form.markInvalidField(workspaceDomainInput);
                    requestAnimationFrame(() => {
                        real.input.focus(workspaceDomainInput);
                    });
                }
                checkCreateEnabled();
            }
        });
    });

    if (workspaceNameInput.val().trim() === '' && blueprintName !== '') {
        workspaceNameInput.val(blueprintName);
        syncDomainFromWorkspaceName();
        validateWorkspaceDomain();
    }

    togglePaidFields();
    checkCreateEnabled();
};
